import callApiBase from './base';

const cardReceivablesApi = {
  getPendencies: ({
    cardNumber,
    expirationDate,
    transportOperatorId,
  }: {
    cardNumber: string;
    expirationDate: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingList',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Get Pendencies',
      data: { cardNumber, expirationDate, transportOperatorId },
    }),

  generatePayment: ({
    transactionIds,
    transportOperatorId,
    transportOperatorName,
  }: {
    cardNumber: string;
    transactionIds: string[];
    transportOperatorId: string;
    transportOperatorName: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPay',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Generate Payment',
      data: { ids: transactionIds, transportOperatorId, transportOperatorName },
    }),

  getHistory: ({
    cardNumber,
    expirationDate,
    transportOperatorId,
  }: {
    cardNumber: string;
    expirationDate: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingHistory',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Get History',
      data: { cardNumber, expirationDate, transportOperatorId },
    }),

  refreshPayment: ({
    paymentId,
    transportOperatorId,
  }: {
    paymentId: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPaymentRefresh',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Refresh Payment',
      data: { paymentId, transportOperatorId },
    }),

  releasePayment: ({
    paymentId,
    transportOperatorId,
  }: {
    paymentId: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPaymentRelease',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Release Payment',
      data: { paymentId, transportOperatorId },
    }),

  /*
   * Endpoints públicos (passageiro, sem login): não usam token e exigem
   * recaptcha nas chamadas de consulta e geração de PIX.
   */
  getPublicPendencies: ({
    cardNumber,
    expirationDate,
    transportOperatorId,
    recaptcha,
  }: {
    cardNumber: string;
    expirationDate: string;
    transportOperatorId: string;
    recaptcha: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPublicList',
      method: 'POST',
      useToken: false,
      title: 'Card Receivables - Get Public Pendencies',
      data: { cardNumber, expirationDate, transportOperatorId, recaptcha },
    }),

  generatePublicPayment: ({
    ids,
    transportOperatorId,
    recaptcha,
  }: {
    ids: string[];
    transportOperatorId: string;
    recaptcha: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPublicPay',
      method: 'POST',
      useToken: false,
      title: 'Card Receivables - Generate Public Payment',
      data: { ids, transportOperatorId, recaptcha },
    }),

  getPublicPaymentStatus: ({
    paymentId,
    transportOperatorId,
    checkProvider,
  }: {
    paymentId: string;
    transportOperatorId: string;
    /** true consulta o PSP (limitado); omitido só lê o banco (polling) */
    checkProvider?: boolean;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPublicStatus',
      method: 'POST',
      useToken: false,
      title: 'Card Receivables - Get Public Payment Status',
      data: {
        paymentId,
        transportOperatorId,
        ...(checkProvider ? { checkProvider: true } : {}),
      },
    }),
};

export { cardReceivablesApi };
export default cardReceivablesApi;
